import React from "react";

const STYLES = {
  pronta_consegna: { cls: "badge-status badge-status-green", dot: "#10b981" },
  ordinabile_breve: { cls: "badge-status badge-status-amber", dot: "#f59e0b" },
  prenotabile_lungo: { cls: "badge-status badge-status-blue", dot: "#3b82f6" },
  non_disponibile: { cls: "badge-status badge-status-gray", dot: "#6b7280" },
};

export default function StatusBadge({ status, statuses }) {
  const config = (statuses || []).find((s) => s.key === status);
  const label = config?.label || status;
  const style = STYLES[status] || STYLES.non_disponibile;
  return (
    <span data-testid={`status-badge-${status}`} className={style.cls}>
      <span
        className="w-1.5 h-1.5 rounded-full inline-block"
        style={{ background: config?.color || style.dot }}
      />
      {label}
    </span>
  );
}
